import React, { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const MessageDialogContext = createContext();

export const MessageDialogProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    title: "Message",
    message: "",
  });

  const showMessage = (title, message) => {
    setState({
      open: true,
      title,
      message,
    });
  };

  const closeMessage = () => {
    setState((prev) => ({ ...prev, open: false }));
  };

  return (
    <MessageDialogContext.Provider value={{ showMessage }}>
      {children}

      <Dialog open={state.open} onClose={closeMessage} maxWidth="xs" fullWidth>
        <DialogTitle>{state.title}</DialogTitle>
        <DialogContent>
          <Typography>{state.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeMessage} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </MessageDialogContext.Provider>
  );
};

export const useMessageDialog = () => useContext(MessageDialogContext);
